import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Error403Page.css';
import { log, logError } from '../../utils/logger';

const Error403Page = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();

  useEffect(() => {
    // Si el usuario no está autenticado, redirigir a 401
    if (!token || !user) {
      log('Error403Manager: Usuario no autenticado, redirigiendo a 401');
      navigate('/401', { replace: true });
      return;
    }

    // Mostrar información del usuario si está disponible
    if (user) {
      try {
        const permissions = user.permissions || [];
        log('Error403Manager: Usuario actual:', user);
        log('Error403Manager: Permisos:', permissions);
      } catch (e) {
        logError('Error403Manager: Error parseando datos del usuario:', e);
      }
    }

    // Configurar redirección automática después de 30 segundos
    const timeoutId = setTimeout(() => {
      log('Error403Manager: Redirección automática al inicio');
      navigate('/', { replace: true });
    }, 30000);

    return () => clearTimeout(timeoutId);
  }, [token, user, navigate]);

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="error-page error-403">
      <div className="error-content">
        <div className="error-icon">
          <i className="fas fa-ban" />
        </div>

        <h1 className="error-code">403</h1>
        <h2 className="error-title">Acceso Prohibido</h2>
        <p className="error-description">
          No tienes los permisos necesarios para acceder a esta área.
        </p>

        <div className="error-actions">
          <button type="button" className="btn btn-primary" onClick={handleGoHome}>
            <i className="fas fa-home" />
            Ir al Inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error403Page;





